export default {
  HOCKEY: 'Hockey',
  CRICKET: 'Cricket',
  FOOTBALL: 'Footy / Aussie Rules Football',
  LACROSSE: 'Lacrosse',
  SOCCER: 'Football / Soccer',
  NETBALL: 'Netball',
  BASKETBALL: 'Basketball',
  LEAGUE: 'Rugby',
  TEAM_POKER: 'Team Poker',
  TOUCH_FOOTBALL: 'Touch Football',
  WATER_POLO: 'Water Polo',
  LAWN_BOWLS: 'Lawn Bowls',
  BASEBALL: 'Baseball',
  VOLLEYBALL: 'Volleyball',
  UNION: 'Rugby',
  SOFTBALL: 'Softball',
  OZTAG: 'Oztag',
  GENERIC: 'Other',
};
